import { DataBean } from "../DataBean";


export class RequestTypeBpmAccount extends DataBean {

    public async getRequestTypeBpmAccountCatalogPorPropiedades(props: any, maxRows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getRequestTypeBpmAccountCatalogPorPropiedades_java.util.Map_Number", [props, maxRows]);
    }

    public async getRequestTypeBpmCatalogByIDAccount(idAccount: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getRequestTypeBpmCatalogByIDAccount_Number", [idAccount]);
    }

    public async deleteRequestTypeBpmAccount(idrequesttypebpmaccount): Promise<any> {
        return this.getCustomService("FinanceCore", "boolean_deleteRequestTypeBpmAccount_Number", [idrequesttypebpmaccount]);
    }

    public async updateRequestTypeBpmAccount(bean: any): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "com.orange.bean.RequestTypeBpmAccount_updateRequestTypeBpmAccount_com.orange.bean.RequestTypeBpmAccount",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.bean.RequestTypeBpmAccount"
                }
            ]
        );
    }

}